// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /team/list.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeTeamListBody,
  typeTeamListOutput200,
} from "../../sdk/team/postTeamList";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildTeamListQueryKey(payload: typeTeamListBody): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`leagueId:${JSON.stringify(payload.leagueId)}`);
  return ["post:team:teamList", "svc:sports-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeTeamListOutput200,
    unknown,
    typeTeamListOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useTeamList(
  payload: typeTeamListBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildTeamListQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postTeamList(payload),
    ...resolvedOptions,
  });
}
